import React from "react";

export const BioBadgeStyle: React.CSSProperties = {
  backgroundColor: "#77A04A", // Grünton (Bio)
  color: "#fff",
  fontSize: "1.5rem",
  fontWeight: 600,
  padding: "6px 12px",
  borderRadius: "5px",
  display: "inline-block",
  fontFamily: "Avenir Next Codensed Regular",
  letterSpacing: ".05em",
  textTransform: "uppercase",
};

export const VeganBadgeStyle: React.CSSProperties = {
  backgroundColor: "#514633", // Dunkles Braungrün für Kontrast
  color: "#A8D164", // Helles Grün (Vegan)
  fontSize: "1.5rem",
  fontWeight: 600,
  padding: "6px 12px",
  borderRadius: "5px",
  display: "inline-block",
  fontFamily: "Avenir Next Codensed Regular",
  letterSpacing: ".05em",
  textTransform: "uppercase",
};

export const VegetarianBadgeStyle: React.CSSProperties = {
  backgroundColor: "#F6F4F2", // dein Hintergrundbeige
  color: "#c39d63", // Golden-Beige
  border: "2px solid #c39d63",
  fontSize: "1.5rem",
  fontWeight: 600,
  padding: "6px 12px",
  borderRadius: "5px",
  display: "inline-block",
  fontFamily: "Avenir Next Codensed Regular",
  letterSpacing: ".05em",
  textTransform: "uppercase",
};